'use client';

import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const subscribe = (onChange: () => void): (() => void) => {
  const mediaQuery = window.matchMedia(QUERY);
  mediaQuery.addEventListener('change', onChange);
  return () => mediaQuery.removeEventListener('change', onChange);
};

const getSnapshot = (): boolean => window.matchMedia(QUERY).matches;

// SSR has no `window`; assume motion is allowed and let the client correct it.
const getServerSnapshot = (): boolean => false;

/**
 * Tracks the user's `prefers-reduced-motion` setting. Dependency-free
 * replacement for framer-motion's `useReducedMotion`, so motion-gated UI (e.g.
 * the typewriter placeholder) doesn't pull framer-motion into its bundle.
 */
export const usePrefersReducedMotion = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
